import colors from 'vuetify/lib/util/colors'



export default {
    theme: {
      options: { customProperties: true },
    },
 options: { customProperties: true },

    themeColor: "#E8E7E7",
    primary: "#1b99a7",
    secondary: '#666666',

    background: "#F0F0F0", // Not automatically applied
    text:{
      'primary': '#fff',
      'theme': "#494949"
    }
}
